import { Trans } from "@lingui/react/macro";

import type { DataTableColumn, DataTableInstance } from "../table-features";

import { cn } from "../../../../../utils/shadcn-ui";
import { BaseCheckbox } from "../../../fields/base-checkbox";
import { setColumnVisible } from "../column-visibility";
import { GROUP_HEADING_CLASS } from "./styles";

/**
 * Checkbox list toggling which columns the table renders. Sticky columns are
 * listed too, but locked on — they anchor the horizontal scroll.
 */
export function ColumnVisibilityPanel<T>({
  table,
  columns,
}: {
  table: DataTableInstance<T>;
  columns: DataTableColumn<T>[];
}) {
  return (
    <>
      {/* Same treatment as the Filters tab's group headings, so both tabs open
          with a label saying what the list below controls. */}
      <div className={GROUP_HEADING_CLASS}>
        <Trans>Displayed columns</Trans>
      </div>
      <div className="px-1.5 pb-1">
        {columns.map((column) => {
          const meta = column.columnDef.meta?.column;
          const canHide = column.getCanHide();
          return (
            <BaseCheckbox
              key={column.id}
              labelClassName={cn(
                // A full-width row, like the filter options in the other
                // tab - this is a list to pick from, not text beside a box.
                "flex gap-2.5 px-3 py-1.5 rounded-md text-sm",
                canHide ? "hover:bg-muted" : "text-muted-foreground/60",
              )}
              checked={column.getIsVisible()}
              disabled={!canHide}
              onCheckedChange={(checked) =>
                setColumnVisible(table, column, checked === true)
              }
              // Same precedence as the filter fields, so a column is named
              // identically in both tabs — and a header carrying a tooltip icon
              // or other decoration is replaced by its plain-text label.
              label={meta?.filter?.label ?? meta?.label ?? meta?.header}
            />
          );
        })}
      </div>
    </>
  );
}
